export default "__VITE_ASSET__BXNTIIGQ__"